import { Component } from '@angular/core';

@Component({
    selector: 'app-shipping-packaging',
    templateUrl: './shipping-packaging.component.html',
    styleUrls: ['./shipping-packaging.component.scss'],
    standalone: false
})
export class ShippingPackagingComponent {

}
